var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_3703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7207 21.2628L5.3179 17.5845C4.09596 15.8499 3.54904 13.729 3.77979 11.6199C4.01054 9.5107 5.0031 7.55825 6.57118 6.12891C8.13927 4.69957 10.1751 3.89161 12.2966 3.85665C14.4181 3.82169 16.4794 4.56214 18.0938 5.93904C19.7081 7.31594 20.7644 9.23463 21.0645 11.335C21.3647 13.4355 20.8879 15.5732 19.7238 17.3471C18.5597 19.121 16.7882 20.409 14.7418 20.9696C12.6954 21.5301 10.5147 21.3246 8.60911 20.3916L3.7207 21.2628Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52832 10.6121C9.52832 10.7405 9.57931 10.8636 9.67008 10.9544C9.76085 11.0451 9.88396 11.0961 10.0123 11.0961C10.1407 11.0961 10.2638 11.0451 10.3546 10.9544C10.4453 10.8636 10.4963 10.7405 10.4963 10.6121V9.64415C10.4963 9.51578 10.4453 9.39268 10.3546 9.30191C10.2638 9.21115 10.1407 9.16016 10.0123 9.16016C9.88396 9.16016 9.76085 9.21115 9.67008 9.30191C9.57931 9.39268 9.52832 9.51578 9.52832 9.64415V10.6121ZM9.52832 10.6121C9.52832 11.8957 10.0382 13.1268 10.9459 14.0345C11.8536 14.9421 13.0847 15.452 14.3683 15.452M14.3683 15.452H15.3363C15.4647 15.452 15.5878 15.401 15.6786 15.3103C15.7693 15.2195 15.8203 15.0964 15.8203 14.968C15.8203 14.8397 15.7693 14.7166 15.6786 14.6258C15.5878 14.535 15.4647 14.4841 15.3363 14.4841H14.3683C14.24 14.4841 14.1169 14.535 14.0261 14.6258C13.9353 14.7166 13.8843 14.8397 13.8843 14.968C13.8843 15.0964 13.9353 15.2195 14.0261 15.3103C14.1169 15.401 14.24 15.452 14.3683 15.452Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_3703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.232,
    height: 23.2315,
    fill: "white",
    transform: "translate(0.816406 0.9375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.a267ba57d77bc0b5bf5299e93b210901.svg";
export { ForwardRef as ReactComponent };